/*
Sohel 03/24/2023 2701335619 Added Logic Field in Fields
Sohel 03/28/2023 2701335619 processor fields added logic field
Sohel 04/27/2023 4136387705 Added Data Calculation Field
uday 10/03/2023 4136387705 fixed table alignemts issues
Sohel 12/12/2023 2701335619 column name change code to name 
*/
import React, {createRef, useState, useEffect} from 'react';
import {TablePagination, Grid} from '@material-ui/core';
import {tableIcons} from '../../../../../../components/TableIcons';
import GuiTable from '../../../../../../components/FormComponents/GuiTable';
import {defaultRows} from '../../../../../../constants/ReusableTablePagination';
import {tablePageRows} from '../../../../../../constants/ReusableConstants';
import {httpPaginationPost} from '../../../../../../util/Rest';
import {useDispatch} from 'react-redux';
import {getFields} from '../../../../../../components/UDW/Components/SearchFieldsTable';

function SearchTable({
  searchData,
  submit,
  setSubmit,
  dmValues,
  setTempSelectedRows,
  tempSelectedRows,
  tempUnCheckedRef,
  isRecordFormat = false,
  isTriggerMaintenance = false,
  isCustomWindow = false,
}) {
  const tableRef = createRef();
  const [rows, setRows] = useState(defaultRows);
  const [arrayLast, setArrayLast] = useState(false);
  const dispatch = useDispatch();

  const columns = [
    {
      title: 'Category',
      render: (rowData) => {
        return rowData?.category === 'CL' ?
          `CL - Client` :
          rowData?.category === 'CO' ?
          `CO - Core` :
            '';
      },
      width: '1%',
    },
    {
      title: 'Data Calculation Name',
      field: 'dcCode',
    },
    {
      title: 'Data Calculation Description',
      field: 'description',
    },
    {
      title: 'Field Type',
      field: 'returnType',
    },
  ];

  useEffect(() => {
    if (tableRef?.current && submit) {
      Object.keys(searchData).length > 0 ? tableRef.current.onQueryChange() : '';
    }
  }, [submit]);
  console.log(dmValues, 'DmValues');
  return (
    <>
      <Grid item xs={12}>
        <div className="custom-table global-field-table custom-toolbar-icons custom-actions-icon new-standard-textfields tablescroll-block">
          <GuiTable
            title={''}
            columns={columns}
            icons={tableIcons}
            tableRef={tableRef}
            onSelectionChange={(rows, row) => {
              if (row?.tableData?.checked) {
                if (tempSelectedRows) {
                  const arr = [...tempSelectedRows].filter((el) => el.tableData.checked);
                  arr.push({
                    ...row,
                    tableData: {...row.tableData, id: row.fieldName + row.repositoryName},
                    mapFieldType: 'Data Calculation Field',
                    fieldHeader: row.fieldName,
                    fieldPosition: '',
                    startPosition: '',
                    fieldLength: '',
                    format: '',
                    fieldName: row.fieldName,
                    dataType: row.dataType,
                    fieldLabel: row.fieldName,
                    viewOnly: 'N',
                    isMandatory: 'N',
                    fieldType: isTriggerMaintenance ? row?.dataType : row?.fieldType,
                    ...(isCustomWindow &&
                      getFields({...row, fieldCode: 'Data Calculation Field'})),
                  });
                  setTempSelectedRows(arr);
                }
              } else {
                tempUnCheckedRef.current.push(row);
                if (isTriggerMaintenance) {
                  const updatedRows = [...tempSelectedRows]
                    .filter(
                      (ele) =>
                        ele?.fieldName + ele?.repositoryName !==
                        row?.fieldName + row?.repositoryName,
                    )
                    .map((ele) => {
                      return {
                        ...ele,
                        tableData: {
                          ...ele.tableData,
                          id: ele.fieldName + ele?.repositoryName,
                        },
                      };
                    });
                  setTempSelectedRows(updatedRows);
                }
                if (!isTriggerMaintenance) {
                  const updatedRows = [...tempSelectedRows]
                    .filter(
                      (ele) =>
                        ele?.fieldName + ele?.repositoryName + ele?.mapFieldType !==
                        row?.fieldName + row?.repositoryName + row?.mapFieldType,
                    )
                    .map((ele) => {
                      return {
                        ...ele,
                        tableData: {
                          ...ele.tableData,
                          id: ele.fieldName + ele?.repositoryName,
                        },
                      };
                    });
                  setTempSelectedRows(updatedRows);
                }
                if (isCustomWindow) {
                  const updatedRows = [...tempSelectedRows]
                    .filter(
                      (ele) =>
                        ele?.fieldName + ele?.repositoryName !==
                        row?.fieldName + row?.repositoryName,
                    )
                    .map((ele) => {
                      return {
                        ...ele,
                        tableData: {
                          ...ele.tableData,
                          id: ele.fieldName + ele?.repositoryName,
                        },
                      };
                    });
                  setTempSelectedRows(updatedRows);
                }
              }
            }}
            data={(query) =>
              new Promise((resolve) => {
                const url = `rules/searchall/calculationrepodetails`;
                const bodyObj = {
                  category: searchData?.category?.categoryCode ?
                    searchData?.category?.categoryCode :
                    '',
                  description: searchData?.fieldName ? searchData?.fieldName : '',
                  limit: query?.pageSize ? query?.pageSize : null,
                  orderDirection: query?.orderDirection ? query?.orderDirection : '',
                  orderBy: query?.orderBy && query?.orderBy?.field ? query?.orderBy?.field : '',
                  page: submit ?
                    1 :
                    arrayLast && query?.page >= 1 ?
                      query.page :
                      arrayLast ?
                        (query.page <= 1 && query.page + 1) || query.page - 1 :
                        query.page + 1,
                  dataCalculationCode: searchData?.repositoryName ? searchData?.repositoryName : '',
                  returnType: searchData?.fieldType ? searchData?.fieldType : '',
                };

                if (!searchData) {
                  resolve({
                    data: [],
                    page: 0,
                    totalCount: 0,
                  });
                } else {
                  httpPaginationPost(url, bodyObj)
                    .then((response) => {
                      if (response?.status === 200) {
                        const data = response.data.response.resultObjects;
                        const newObj = {};
                        if (!isTriggerMaintenance && !isCustomWindow) {
                          if (isRecordFormat && dmValues) {
                            [...dmValues.selectedFields, ...tempSelectedRows].forEach((el) => {
                              if (!newObj[el.fieldName + el.repositoryName + el.mapFieldType]) {
                                newObj[el.fieldName + el.repositoryName + el.mapFieldType] = el;
                              }
                            });
                          } else {
                            [...dmValues.selectedFields, ...tempSelectedRows].forEach((el) => {
                              if (
                                !newObj[el.fieldName + el.repositoryName + el.processorFieldType]
                              ) {
                                newObj[el.fieldName + el.repositoryName + el.processorFieldType] =
                                  el;
                              }
                            });
                          }
                        }
                        if (isTriggerMaintenance || isCustomWindow) {
                          [...dmValues, ...tempSelectedRows].forEach((el) => {
                            if (!newObj[el.fieldName + el.repositoryName]) {
                              newObj[el.fieldName + el.repositoryName] = el;
                            }
                          });
                        }
                        const newData = data?.map((el) => {
                          return {
                            ...el,
                            mapFieldType: 'Data Calculation Field',
                            repositoryName: 'DATA_CALCULATION_FIELD',
                            fieldName: el?.dcCode || '',
                            dataType: el?.returnType || '',
                            processorFieldType: 'Data Calculation Field',
                          };
                        });
                        const newRows =
                          isTriggerMaintenance || isCustomWindow ?
                            newData?.map((elem) => {
                              if (newObj[elem.fieldName + elem.repositoryName]) {
                                return {
                                  ...elem,
                                  tableData: {...elem.tableData, checked: true},
                                };
                              } else {
                                return {
                                  ...elem,
                                  tableData: {...elem.tableData, checked: false},
                                };
                              }
                            }) :
                            newData?.map((elem) => {
                              if (
                                newObj[elem.fieldName + elem.repositoryName + elem.mapFieldType]
                              ) {
                                return {
                                  ...elem,
                                  tableData: {...elem.tableData, checked: true},
                                };
                              } else {
                                return {
                                  ...elem,
                                  tableData: {...elem.tableData, checked: false},
                                };
                              }
                            });
                        resolve({
                          data: newRows?.length > 0 ? newRows : data.length > 0 ? data : [],
                          page: response.data.response.page - 1,
                          totalCount: response.data.response.count,
                        });
                        setArrayLast(data.length === 1);
                        setSubmit(false);
                      } else {
                        resolve({
                          data: [],
                          page: 0,
                          totalCount: 5,
                        });
                        dispatch({
                          type: 'FETCH_ERROR',
                          payload: response && response.message ? response.message : null,
                        });
                      }
                    })
                    .catch((response) => {
                      resolve({
                        data: [],
                        page: 0,
                        totalCount: 5,
                      });
                      dispatch({
                        type: 'FETCH_ERROR',
                        payload: response && response.message ? response.message : null,
                      });
                    });
                }
              })
            }
            options={{
              search: false,
              pageSize: rows,
              toolbar: false,
              toolbarButtonAlignment: 'left',
              showSelectAllCheckbox: false,
              emptyRowsWhenPaging: false,
              selection: true,
              selectionProps: (rowData) => {
                let disabledFields = false;
                const checked = rowData?.active === 'no' ? {checked: false} : {};
                dmValues?.selectedFields?.forEach((el) => {
                  if (
                    el.repositoryName?.concat(el.fieldName)?.concat(el?.fieldType) ===
                      rowData.repositoryName
                        ?.concat(rowData?.fieldName)
                        ?.concat(rowData?.mapFieldType) &&
                    (el?.tabType === 'Record Format Field' || el?.isEditable === false)
                  ) {
                    disabledFields = true;
                  }
                });
                return {
                  disabled: isTriggerMaintenance ? false : disabledFields,
                  ...checked,
                };
              },
              headerStyle: {
                fontWeight: 'bold',
              },
            }}
            components={{
              Pagination: (props) => (
                <div className="global-field-table-footer">
                  <TablePagination
                    {...props}
                    SelectProps={{
                      inputProps: {'aria-label': 'Rows per screen'},
                    }}
                    labelRowsPerPage={'Rows per screen:'}
                    rowsPerPageOptions={tablePageRows}
                    onChangeRowsPerPage={(event) => {
                      props.onChangeRowsPerPage(event);
                      setRows(event.target.value);
                    }}
                  />
                </div>
              ),
            }}
          />
        </div>
      </Grid>
    </>
  );
}

export default SearchTable;
